import { gql } from "@apollo/client";

const GET_CLIENT_MESSAGE_EMAIL_TEMPLATES = gql`
  query getClientMessageEmailTemplates {
    clientMessageTemplatesCollection {
      items {
        id
        title
        content
      }
    }
  }
`;

export default GET_CLIENT_MESSAGE_EMAIL_TEMPLATES;
